/*
 * Agenda React — le gros du style provient des feuilles existantes enqueuées
 * côté PHP (gas-agenda.css + gas-card.css), réutilisées via les mêmes classes
 * BEM gas-agenda__* / gas-card. Styles d'appoint uniquement ici.
 */
.gas-agenda__loading {
    padding: var(--gas-space-2xl);
    text-align: center;
    color: var(--gas-text-color-light);
}

/* Vue carte (Lot 4 — activites-membres-carte) */
.gas-agenda__map {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-3, 12px);
}

.gas-agenda__map-count {
    margin: 0;
    color: var(--gas-color-text-muted, #666);
    font-size: var(--gas-font-size-sm, 14px);
}

.gas-agenda__map-empty {
    padding: var(--gas-space-xl, 32px);
    text-align: center;
    color: var(--gas-color-text-muted, #666);
}

.gas-agenda__map-canvas {
    height: min(70vh, 512px);
    min-height: 288px;
    border-radius: var(--gas-radius-md, 8px);
    overflow: hidden;
    border: 1px solid var(--gas-color-border, #e5e5e5);
}

.gas-agenda__map-popup {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-1, 4px);
    max-width: 224px;
}

.gas-agenda__map-popup-image {
    width: 100%;
    height: 88px;
    object-fit: cover;
    border-radius: var(--gas-radius-sm, 4px);
}

.gas-agenda__map-popup-title {
    margin: 0;
    font-weight: 600;
    font-size: var(--gas-font-size-sm, 14px);
}

.gas-agenda__map-popup-meta {
    margin: 0;
    color: var(--gas-color-text-muted, #666);
    font-size: var(--gas-font-size-xs, 12px);
}

.gas-agenda__map-popup-link {
    margin-top: var(--gas-space-1, 4px);
    font-size: var(--gas-font-size-sm, 14px);
}
